module.exports = __webpack_public_path__ + "static/media/windows.a4f5b841.png";